// import React, { useRef, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import logo from "../../Images/logo2.png";

// const Invoiceform = () => {
//   const printRef = useRef();

//   const [form, setForm] = useState({
//     invoiceNo: "",
//     refNo: "",
//     date: "",
//     to: "",
//     bank: "",
//     borrower: "",
//     particulars: "",
//     propertyValue: "",
//     rate: "",
//     taxable: "",
//     sgst: "",
//     cgst: "",
//     total: "",
//     words: "",
//   });

//   const handleChange = (e) => {
//     setForm({
//       ...form,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handlePrint = () => {
//     const printContents = printRef.current.innerHTML;

//     const logoImg = document.getElementById("invoiceLogo");
//     const logoSrc = logoImg.src;

//     const printWindow = window.open("", "", "width=1000,height=700");

//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Invoice</title>

//           <link
//             rel="stylesheet"
//             href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
//           />

//           <style>
//             body{
//               padding:10px;
//               margin:0;
//               font-family:'Times New Roman', serif;
//             }

//             table{
//               width:100%;
//               border-collapse:collapse;
//               page-break-inside: avoid;
//             }

//             table, th, td{
//               border:1px solid #000 !important;
//             }

//             tr, td, th{
//               page-break-inside: avoid !important;
//             }

//             th, td{
//               padding:4px !important;
//               font-size:12px;
//             }

//             input,
//             textarea{
//               border:none !important;
//               outline:none !important;
//               box-shadow:none !important;
//               resize:none;
//               width:100%;
//             }

//             textarea{
//               min-height:40px !important;
//             }

//             @page{
//               size:auto;
//               margin:10mm;
//             }
//           </style>
//         </head>

//         <body>
//           ${printContents.replace(
//             /src="[^"]*"/,
//             `src="${logoSrc}"`
//           )}
//         </body>
//       </html>
//     `);

//     printWindow.document.close();

//     printWindow.onload = () => {
//       printWindow.print();
//     };
//   };

//   return (
//     <div className="container py-3">
//       <div className="text-end mb-3">
//         <button
//           style={{
//             background: "#7D4B3C",
//             color: "#fff",
//             borderRadius: "6px",
//             border: "none",
//             padding: "6px 12px",
//           }}
//           onClick={handlePrint}
//         >
//           Print
//         </button>
//       </div>

//       <div
//         ref={printRef}
//         className="bg-white "
//         style={{
//           padding: "5px",
//           pageBreakInside: "avoid",
//         }}
//       >
//         {/* HEADER */}
//         <table
//           className="table table-bordered mb-0"
//           style={{
//             marginBottom: "0",
//             pageBreakInside: "avoid",
//           }}
//         >
//           <tbody>
//             <tr>
//               <td
//                 style={{
//                   width: "180px",
//                   verticalAlign: "middle",
//                   textAlign: "center",
//                 }}
//               >
//                 {/* <img
//                   src={logo}
//                   alt="logo"
//                   id="invoiceLogo"
//                   style={{ width: "100px" }}
//                 /> */}
//                 <img
//   src={logo}
//   alt="logo"
//   id="invoiceLogo"
//   style={{
//     width: "150px",
//     height: "150px",
//     objectFit: "contain",
//   }}
// />
//               </td>

//               <td className="text-center">
//                 <h2 className="fw-bold mb-1" style={{ color: "#3d5f27" }}>
//                   Er. Dhiraj Kumar Panda
//                 </h2>

//                 <div style={{ fontSize: "14px" }}>
//                   M.tech, AMIE, IOV, CIV
//                   <br />
//                 Chartered Engineer- <b>AM3059149</b>
//                   <br />
//                   Regd Technical Persons(ODA)
//                   <br />
//                   Govt. Regd Valuer
//                   <br />
//                  <b> GSTIN- 21COEPP2768E1Z2</b>
//                   <br />
//                   <b>SAC -998393</b>
//                 </div>
//               </td>
//             </tr>

//             <tr>
//               <td colSpan="2" className="text-center">
//                 Registered Office - Baidyanath Nagar 3rd Lane, Saletax Square,<br/>
//                 Berhampur, Ganjam, 760010
//               </td>
//             </tr>

//           <tr>
//   <td
//     style={{
//       width: "50%",
//       textAlign: "center",
//     }}
//   >
//     Phone no. - +91-7008359806
//   </td>

//   <td
//     style={{
//       width: "50%",
//       textAlign: "center",
//     }}
//   >
//     Email id - dhiraj.dk26@gmail.com
//   </td>
// </tr>
//           </tbody>
//         </table>

//         <table
//           className="table table-bordered mb-0"
//           style={{
//             marginBottom: "0",
//             pageBreakInside: "avoid",
//           }}
//         >
//           <tbody>
//             <tr>
//               <td style={{ width: "50%", height: "130px" }}>
//                 <b>To,</b><br/>
//                <b> Bank details</b>

//                 <textarea
//                   rows="3"
//                   name="to"
//                   value={form.to}
//                   onChange={handleChange}
//                   className="form-control border-0"
//                     style={{
//     resize: "none",
//     outline: "none",
//     boxShadow: "none",
//     border: "none",
//   }}
//                 />
// {/* 
//                 <b>Bank Details</b>

//                 <textarea
//                   rows="2"
//                   name="bank"
//                   value={form.bank}
//                   onChange={handleChange}
//                   className="form-control border-0"
//                     style={{
//     resize: "none",
//     outline: "none",
//     boxShadow: "none",
//     border: "none",
//   }}
//                 /> */}
//               </td>

//               <td>
//                 <b>Borrower Details :-</b>

//                 <textarea
//                   rows="7"
//                   name="borrower"
//                   value={form.borrower}
//                   onChange={handleChange}
//                   className="form-control border-0"
//                     style={{
//     resize: "none",
//     outline: "none",
//     boxShadow: "none",
//     border: "none",
//   }}
//                 />
//               </td>
//             </tr>
//           </tbody>
//         </table>

//         <table
//           className="table table-bordered mb-0"
//           style={{
//             marginBottom: "0",
//             pageBreakInside: "avoid",
//           }}
//         >
//           <tbody>
//             <tr>
//               <td>
//                 Invoice No. -
//                 <input
//                   type="text"
//                   name="invoiceNo"
//                   value={form.invoiceNo}
//                   onChange={handleChange}
//                   className="form-control border-0"
//                 />
//               </td>

//               <td>
//                 Ref No. -
//                 <input
//                   type="text"
//                   name="refNo"
//                   value={form.refNo}
//                   onChange={handleChange}
//                   className="form-control border-0"
//                 />
//               </td>

//               <td>
//                 Date
//                 <input
//                   type="date"
//                   name="date"
//                   value={form.date}
//                   onChange={handleChange}
//                   className="form-control border-0"
//                 />
//               </td>
//             </tr>
//           </tbody>
//         </table>

//         {/* MAIN TABLE */}
//         <table
//           className="table table-bordered mb-0"
//           style={{
//             marginBottom: "0",
//             pageBreakInside: "avoid",
//           }}
//         >
//           <thead>
//             <tr>
//               <th style={{ width: "8%" }}>Sl. No.</th>
//               <th>Particulars</th>
//               <th style={{ width: "22%" }}>Property Value</th>
//               <th style={{ width: "18%" }}>Rate as of</th>
//             </tr>
//           </thead>

//           <tbody>
//             <tr>
//               <td>1</td>

//               <td>
//                 <input
//                   type="text"
//                   name="particulars"
//                   value={form.particulars}
//                   onChange={handleChange}
//                   className="form-control border-0"
//                 />
//               </td>

//               <td>
//                 <input
//                   type="text"
//                   name="propertyValue"
//                   value={form.propertyValue}
//                   onChange={handleChange}
//                   className="form-control border-0"
//                 />
//               </td>

//               <td>
//                 <input
//                   type="text"
//                   name="rate"
//                   value={form.rate}
//                   onChange={handleChange}
//                   className="form-control border-0"
//                 />
//               </td>
//             </tr>

//             {[...Array(4)].map((_, i) => (
//               <tr key={i}>
//                 <td>{i + 2}</td>
//                 <td></td>
//                 <td></td>
//                 <td></td>
//               </tr>
//             ))}

//             <tr>
//               <td colSpan="2"></td>
//               <td>Total Taxable Amount</td>
//               <td>
//                 <input
//                   type="text"
//                   name="taxable"
//                   value={form.taxable}
//                   onChange={handleChange}
//                   className="form-control border-0 text-end"
//                 />
//               </td>
//             </tr>

//             <tr>
//               <td colSpan="2"></td>
//               <td>SGST 9%</td>
//               <td>
//                 <input
//                   type="text"
//                   name="sgst"
//                   value={form.sgst}
//                   onChange={handleChange}
//                   className="form-control border-0 text-end"
//                 />
//               </td>
//             </tr>

//             <tr>
//               <td colSpan="2"></td>
//               <td>CGST 9%</td>
//               <td>
//                 <input
//                   type="text"
//                   name="cgst"
//                   value={form.cgst}
//                   onChange={handleChange}
//                   className="form-control border-0 text-end"
//                 />
//               </td>
//             </tr>

//             <tr>
//               <td colSpan="2"></td>
//               <td>
//                 <b>Invoice Amount</b>
//               </td>
//               <td>
//                 <input
//                   type="text"
//                   name="total"
//                   value={form.total}
//                   onChange={handleChange}
//                   className="form-control border-0 text-end fw-bold"
//                 />
//               </td>
//             </tr>

//             <tr>
//               <td colSpan="4">
//                 <b>In words :-</b>
//                 <input
//                   type="text"
//                   name="words"
//                   value={form.words}
//                   onChange={handleChange}
//                   className="form-control border-0"
//                 />
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default Invoiceform;



import React, { useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../Images/logo2.png";
import { useNavigate } from "react-router-dom";

const Invoiceform = () => {
  const printRef = useRef();

  const [form, setForm] = useState({
    invoiceNo: "",
    refNo: "",
    date: "",
    to: "",
    bank: "",
    borrower: "",
    particulars: "",
    propertyValue: "",
    rate: "",
    taxable: "",
    sgst: "",
    cgst: "",
    total: "",
    words: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };
  const navigate = useNavigate();

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;

    const logoImg = document.getElementById("invoiceLogo");
    const logoSrc = logoImg.src;

    const printWindow = window.open("", "", "width=1000,height=700");

    printWindow.document.write(`
      <html>
        <head>
          <title>Invoice</title>

          <link
            rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
          />

          <style>
            body{
              padding:10px;
              margin:0;
              font-family:'Times New Roman', serif;
            }

            table{
              width:100%;
              border-collapse:collapse;
              page-break-inside: avoid;
            }

            table, th, td{
              border:1px solid #000 !important;
            }

            tr, td, th{
              page-break-inside: avoid !important;
            }

            th, td{
              padding:4px !important;
              font-size:12px;
            }

            input,
            textarea{
              border:none !important;
              outline:none !important;
              box-shadow:none !important;
              resize:none;
              width:100%;
            }

            textarea{
              min-height:40px !important;
            }

            @page{
              size:auto;
              margin:10mm;
            }
          </style>
        </head>

        <body>
          ${printContents.replace(
            /src="[^"]*"/,
            `src="${logoSrc}"`
          )}
        </body>
      </html>
    `);

    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.print();
    };
  };

  return (
    <div
      className="container py-3"
      style={{
        width: "100%",
        maxWidth: "100%",
        overflowX: "auto",
      }}
    >
      {/* <div className="text-end mb-3">
        <button
          style={{
            background: "#7D4B3C",
            color: "#fff",
            borderRadius: "6px",
            border: "none",
            padding: "6px 12px",
          }}
          onClick={handlePrint}
        >
          Print
        </button>
      </div> */}
      <div
  className="mb-3"
  style={{
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  }}
>
  <button
    style={{
      background: "#D4C2BB",
      color: "#7D4B3C",
      borderRadius: "6px",
      border: "none",
      padding: "6px 12px",
    }}
    onClick={() => navigate(-1)}
  >
    Back
  </button>

  <button
    style={{
      background: "#7D4B3C",
      color: "#fff",
      borderRadius: "6px",
      border: "none",
      padding: "6px 12px",
    }}
    onClick={handlePrint}
  >
    Print
  </button>
</div>

      <div
        ref={printRef}
        className="bg-white "
        style={{
          padding: "5px",
          pageBreakInside: "avoid",
        }}
      >
        {/* HEADER */}
        <table
          className="table table-bordered mb-0"
          style={{
            marginBottom: "0",
            pageBreakInside: "avoid",
            width: "100%",
          }}
        >
          <tbody>
            <tr>
              <td
                style={{
                  width: "25%",
                  minWidth: "120px",
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                <img
                  src={logo}
                  alt="logo"
                  id="invoiceLogo"
                  style={{
                    width: "100%",
                    maxWidth: "150px",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </td>

              <td className="text-center">
                <h2 className="fw-bold mb-1" style={{ color: "#3d5f27" }}>
                  Er. Dhiraj Kumar Panda
                </h2>

                <div style={{ fontSize: "14px" }}>
                  M.tech, AMIE, IOV, CIV
                  <br />
                  Chartered Engineer- <b>AM3059149</b>
                  <br />
                  Regd Technical Persons(ODA)
                  <br />
                  Govt. Regd Valuer
                  <br />
                  <b>GSTIN- 21COEPP2768E1Z2</b>
                  <br />
                  <b>SAC -998393</b>
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan="2" className="text-center">
                Registered Office - Baidyanath Nagar 3rd Lane, Saletax Square,
                <br />
                Berhampur, Ganjam, 760010
              </td>
            </tr>

            <tr>
              <td
                style={{
                  width: "50%",
                  textAlign: "center",
                }}
              >
                Phone no. - +91-7008359806
              </td>

              <td
                style={{
                  width: "50%",
                  textAlign: "center",
                }}
              >
                Email id - dhiraj.dk26@gmail.com
              </td>
            </tr>
          </tbody>
        </table>

        <table
          className="table table-bordered mb-0"
          style={{
            marginBottom: "0",
            pageBreakInside: "avoid",
            width: "100%",
          }}
        >
          <tbody>
            <tr>
              <td style={{ width: "50%", height: "130px" }}>
                <b>To,</b>
                <br />
                <b>Bank details</b>

                <textarea
                  rows="3"
                  name="to"
                  value={form.to}
                  onChange={handleChange}
                  className="form-control border-0"
                  style={{
                    resize: "none",
                    outline: "none",
                    boxShadow: "none",
                    border: "none",
                  }}
                />

                {/* 
                <b>Bank Details</b>

                <textarea
                  rows="2"
                  name="bank"
                  value={form.bank}
                  onChange={handleChange}
                  className="form-control border-0"
                    style={{
    resize: "none",
    outline: "none",
    boxShadow: "none",
    border: "none",
  }}
                /> */}
              </td>

              <td>
                <b>Borrower Details :-</b>

                <textarea
                  rows="7"
                  name="borrower"
                  value={form.borrower}
                  onChange={handleChange}
                  className="form-control border-0"
                  style={{
                    resize: "none",
                    outline: "none",
                    boxShadow: "none",
                    border: "none",
                  }}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <table
          className="table table-bordered mb-0"
          style={{
            marginBottom: "0",
            pageBreakInside: "avoid",
            width: "100%",
          }}
        >
          <tbody>
            <tr>
              <td>
                Invoice No. -
                <input
                  type="text"
                  name="invoiceNo"
                  value={form.invoiceNo}
                  onChange={handleChange}
                  className="form-control border-0"
                />
              </td>

              <td>
                Ref No. -
                <input
                  type="text"
                  name="refNo"
                  value={form.refNo}
                  onChange={handleChange}
                  className="form-control border-0"
                />
              </td>

              <td>
                Date
                <input
                  type="date"
                  name="date"
                  value={form.date}
                  onChange={handleChange}
                  className="form-control border-0"
                />
              </td>
            </tr>
          </tbody>
        </table>

        {/* MAIN TABLE */}
        <table
          className="table table-bordered mb-0"
          style={{
            marginBottom: "0",
            pageBreakInside: "avoid",
            width: "100%",
          }}
        >
          <thead>
            <tr>
              <th style={{ width: "8%" }}>Sl. No.</th>
              <th>Particulars</th>
              <th style={{ width: "22%" }}>Property Value</th>
              <th style={{ width: "18%" }}>Rate as of</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>1</td>

              <td>
                <input
                  type="text"
                  name="particulars"
                  value={form.particulars}
                  onChange={handleChange}
                  className="form-control border-0"
                />
              </td>

              <td>
                <input
                  type="text"
                  name="propertyValue"
                  value={form.propertyValue}
                  onChange={handleChange}
                  className="form-control border-0"
                />
              </td>

              <td>
                <input
                  type="text"
                  name="rate"
                  value={form.rate}
                  onChange={handleChange}
                  className="form-control border-0"
                />
              </td>
            </tr>

            {[...Array(4)].map((_, i) => (
              <tr key={i}>
                <td>{i + 2}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            ))}

            <tr>
              <td colSpan="2"></td>
              <td>Total Taxable Amount</td>
              <td>
                <input
                  type="text"
                  name="taxable"
                  value={form.taxable}
                  onChange={handleChange}
                  className="form-control border-0 text-end"
                />
              </td>
            </tr>

            <tr>
              <td colSpan="2"></td>
              <td>SGST 9%</td>
              <td>
                <input
                  type="text"
                  name="sgst"
                  value={form.sgst}
                  onChange={handleChange}
                  className="form-control border-0 text-end"
                />
              </td>
            </tr>

            <tr>
              <td colSpan="2"></td>
              <td>CGST 9%</td>
              <td>
                <input
                  type="text"
                  name="cgst"
                  value={form.cgst}
                  onChange={handleChange}
                  className="form-control border-0 text-end"
                />
              </td>
            </tr>

            <tr>
              <td colSpan="2"></td>
              <td>
                <b>Invoice Amount</b>
              </td>
              <td>
                <input
                  type="text"
                  name="total"
                  value={form.total}
                  onChange={handleChange}
                  className="form-control border-0 text-end fw-bold"
                />
              </td>
            </tr>

            <tr>
              <td colSpan="4">
                <b>In words :-</b>
                <input
                  type="text"
                  name="words"
                  value={form.words}
                  onChange={handleChange}
                  className="form-control border-0"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Invoiceform;